import { CreatableSelect } from "@/components/features/matter/file-repo/GenerateDocument/CreatableSelect";
import {
  formatAttorneyFee,
  isOneThirdAttorneyFee,
} from "@/lib/utils/attorneyFeeUtils";
import { type ComponentProps } from "react";

type AttorneyFeeSelectProps = ComponentProps<typeof CreatableSelect>;

export function AttorneyFeeSelect({
  options,
  value,
  onChange,
  ...props
}: AttorneyFeeSelectProps) {
  const feeOptions = options.map((option) => ({
    ...option,
    label: `${formatAttorneyFee(option.value)}${option.label.endsWith("%") ? "%" : ""}`,
  }));
  if (value && !feeOptions.some((option) => option.value === value)) {
    feeOptions.push({ value, label: formatAttorneyFee(value) });
  }

  return (
    <CreatableSelect
      {...props}
      value={value}
      options={feeOptions}
      onChange={(nextValue) => {
        if (isOneThirdAttorneyFee(nextValue)) {
          onChange("33.33");
        } else if (
          nextValue.trim() &&
          Number.isFinite(Number(nextValue)) &&
          Number(nextValue) >= 0 &&
          Number(nextValue) <= 100
        ) {
          onChange(nextValue);
        }
      }}
    />
  );
}
